module.exports = __webpack_public_path__ + "img/nursenew.95d7c301.png";